import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { activityTracker } from '../../utils/activityTracker';
import { addSampleActivities } from '../../utils/sampleActivities';
import './Home.css';

const Home = () => {
  const [recentActivities, setRecentActivities] = useState({});
  const [allActivities, setAllActivities] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadRecentActivities();
  }, []);

  const loadRecentActivities = () => {
    const moduleActivities = activityTracker.getActivitiesByModule();
    const allRecent = activityTracker.getRecentActivities();
    
    setRecentActivities(moduleActivities);
    setAllActivities(allRecent);
  };

  const handleActivityClick = (activity) => {
    if (activity.data.route) {
      navigate(activity.data.route);
    }
  };

  const handleAddSampleData = () => {
    addSampleActivities();
    loadRecentActivities();
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);

    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now - date) / (1000 * 60));
      return `${diffInMinutes} min atrás`;
    } else if (diffInHours < 24) {
      return `${Math.floor(diffInHours)}h atrás`;
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      return `${diffInDays}d atrás`;
    }
  };

  const getModuleIcon = (moduleName) => {
    const icons = {
      'Estoque': '📦',
      'Pedidos': '📋',
      'Captura inteligente': '🤖'
    };
    return icons[moduleName] || '📁';
  };

  const getModuleColor = (moduleName) => {
    const colors = {
      'Estoque': '#3b82f6',
      'Pedidos': '#10b981',
      'Captura inteligente': '#8b5cf6'
    };
    return colors[moduleName] || '#6b7280';
  };

  const hasActivities = Object.keys(recentActivities).length > 0;

  return (
    <div className="home-page">
      <div className="home-content">
        {hasActivities ? (
          <div className="recent-activities">
            {/* All Recent Activities */}
            <div className="all-activities-section">
              <h3>🕒 Atividades recentes</h3>
              <div className="activities-grid">
              {Object.entries(recentActivities).map(([moduleName, activities]) => (
                <div key={moduleName} className="module-section">
                  <h3>
                    <span className="module-icon">{getModuleIcon(moduleName)}</span>
                    {moduleName}
                  </h3>
                  <div className="module-activities-list">
                    {activities.map((activity) => (
                      <div
                        key={activity.id}
                        className="module-activity-item"
                        onClick={() => handleActivityClick(activity)}
                      >
                        <div className="activity-icon">{activity.icon}</div>
                        <div className="activity-content">
                          <div className="activity-title">{activity.data.description}</div>
                          <div className="activity-time">{formatTimestamp(activity.timestamp)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="">
            <div>
              <div className="empty-icon">🚀</div>
              <h2>Comece a usar o sistema</h2>
              <p>Suas atividades recentes aparecerão aqui para acesso rápido</p>
            </div>
            <div className="quick-access">
              <h2>Acesso Rápido</h2>
              <div className="navigation-grid">
                <Link to="/inventory" className="nav-card">
                  <div className="nav-icon">📦</div>
                  <h3>Estoque</h3>
                  <p>Consulta e gerenciamento de produtos</p>
                </Link>
                
                <Link to="/orders" className="nav-card">
                  <div className="nav-icon">📋</div>
                  <h3>Pedidos</h3>
                  <p>Kanban board para gerenciamento de pedidos</p>
                </Link>
                
                <Link to="/smart-order-capture" className="nav-card">
                  <div className="nav-icon">🤖</div>
                  <h3>Smart Order Capture</h3>
                  <p>Extractão inteligente de pedidos com IA</p>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
